export const baseURL = process.env.REACT_APP_BASE_URL;
// export const baseURL = "http://localhost:8080";

export const Endpoints = {
  GetLoginAdmin: () => `${baseURL}/admin/auth/login`,
  GetRequestOTP: (email: string) => `${baseURL}/admin/auth/otp/${email}`,
  GetVerifyOTPLogin: () => `${baseURL}/admin/auth/otp-login`,
  GetRequestResetLink: (email: string) => `${baseURL}/admin/auth/reset/${email}`,
  GetVerifyResetLink: (resetID: string) =>
    `${baseURL}/admin/auth/reset/verify/${resetID}`,
  GetUpdatePassword: (resetID: string) => `${baseURL}/admin/auth/reset/${resetID}`,
  GetAdminProfile: () => `${baseURL}/admin/auth/profile`,
  GetTeamProfiles: () => `${baseURL}/admin/team`,
  GetOnboardAdminProfile: () => `${baseURL}/admin/onboard`,
  GetUpdateTeamMemberProfile: (adminID: string) =>
    `${baseURL}/admin/other/patch/${adminID}`,
  GetCompleteAdminOnboard: (adminID: string) =>
    `${baseURL}/admin/auth/complete/${adminID}`,
  GetDeleteAdminProfile: (adminID: string) => `${baseURL}/admin/delete/${adminID}`,
  GetUploadFile: () => `${baseURL}/file/upload`,
  GetUpdateSalesRequestStatus: (requestID: string) =>
    `${baseURL}/admin/request/${requestID}`,
  GetDeleteSalesRequest: (requestID: string) => `${baseURL}/admin/request/${requestID}`,
  GetSaleRequests: (page: number, limit: number) =>
    `${baseURL}/admin/requests?page=${page}&limit=${limit}`,
  GetSingleSalesRequest: (requestID: string) => `${baseURL}/admin/request/${requestID}`,
  GetVehicleDetailsWithVIN: (vin: string) =>
    `https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${vin}?format=json`,

  GetAddVehicleToInventory: (requestID: string) =>
    `${baseURL}/admin/vehicle/add/${requestID}`,
  GetCreateVehicleInInventory: () => `${baseURL}/admin/vehicle/create`,
  GetSingleVehicleDetails: (vehicleID: string) =>
    `${baseURL}/admin/inventory/${vehicleID}`,
  // `GetVehiclesInInventory` and `GetFilterVehiclesInInventory` more or less do the same thing
  // `GetFilterVehiclesInInventory` allows for filter using: `sold`, `model`, `manufacturer`, and `year` (all OPTIONAL)
  // GetFilterVehiclesInInventory allows for filter using: sold as boolean (also OPTIONAL)
  GetVehiclesInInventory: (page: number, limit: number) =>
    `${baseURL}/admin/inventory?page=${page}&limit=${limit}`,
  GetFilterVehiclesInInventory: (page: number, limit: number) =>
    `${baseURL}/admin/inventory/filter?page=${page}&limit=${limit}`,
  GetUpdateVehicleStatus: (vehicleID: string) => `${baseURL}/admin/vehicle/${vehicleID}`,
  GetUpdateVehicleDetails: (vehicleID: string) => `${baseURL}/admin/vehicle/${vehicleID}`,
  GetSingleVehicleWithVIN: (vin: string) => `${baseURL}/admin/vehicle/${vin}`,
  GetClientMessages: (page: number, limit: number) =>
    `${baseURL}/admin/messages?page=${page}&limit=${limit}`,
  GetSendEmailResponse: (requestID: string) =>
    `${baseURL}/admin/request/email/${requestID}`,
};
